import { HttpClient } from '@angular/common/http';
import { ReportType } from '@app/domain/model/report-type';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SpeciesService = /** @class */ (function () {
    function SpeciesService(http) {
        this.http = http;
        this.speciesUrl = 'species/';
    }
    SpeciesService.prototype.getSpecies = function (q, reportType) {
        var params = {
            q: q,
            reportType: ReportType[reportType]
        };
        return this.http.get(this.speciesUrl, { params: params });
    };
    SpeciesService.ngInjectableDef = i0.defineInjectable({ factory: function SpeciesService_Factory() { return new SpeciesService(i0.inject(i1.HttpClient)); }, token: SpeciesService, providedIn: "root" });
    return SpeciesService;
}());
export { SpeciesService };
